import { Machine } from "models/Machine";
import { MachineDefect } from "models/MachineDefect";

export class WorkshopDefect {
    id: number;
    machineId: number;
    defect: string;
    description: string;
    checked: boolean;
    
    constructor (
        id:number,
        machineId: number,
        defect: string,
        description: string,
        checked: boolean
    ) {
        this.id = id;
        this.machineId = machineId;
        this.defect = defect;
        this.description = description;
        this.checked = checked;
    }
    static empty(): WorkshopDefect {
        return { 
            id: 0,
            machineId: 0,
            defect: '',
            description: '',
            checked: false,
        };
    }
    static fromMachineDefect(md: MachineDefect, ma: Machine): WorkshopDefect {
        return { 
            id: md.id,
            machineId: ma.id,
            defect: md.defect,
            description: md.description,
            checked: false
        };
    }

}